(function () {
  const carouselContainer = document.querySelector('.yotpo-carousel');
  const bottomLine = document.querySelector('.info-product-detail__rating .yotpo-display-wrapper');
  const productPdp = CurrentProduct;
  var PAGE = 1;
  let intervalId;
  let load_moreVisible = false;

  // Main funtions to initialize
  async function getYotpoReviews(productId, page, per_page) {
    const URI = `https://api-cdn.yotpo.com/v1/widget/71LvKEaaAS6e2QNsOKyGHjeHCgaTM10NJIWnR4uQ/products/${productId}/reviews.json?per_page=${per_page}&page=${page}`
    try {
      const response = await fetch(URI);
      if (!response.ok) {
        throw new Error('Error al obtener reseñas de Yotpo.');
      }
      const data = await response.json();
      const yotpoData = data.response;

      return yotpoData;
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async function renderYotpoCarousel() {
    const carouselContainer = document.querySelector('.yotpo-carousel');
    const carouselPerPage = parseInt(carouselContainer.dataset.carouselPerPage);
    const { reviews, bottomline } = await getYotpoReviews(productPdp.id, 1, carouselPerPage);
    if (bottomline.total_review > 0) {
      for (const review of reviews) {
        const reviewItem = generateReviewHtml(review, true);
        carouselContainer.appendChild(reviewItem);
      }
      waitForElement('.yotpo-carousel').then((elm) => {
        $('.yotpo-carousel').slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 1000,
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true,
          adaptiveHeight: true,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 1000,
                slidesToShow: 1,
                adaptiveHeight: true,
                autoplaySpeed: 5000
              }
            }
          ]
        });
      });


      // Update yotpo rating
      const yotpoReviewsContainers = [...document.querySelectorAll('.baselite-pdp-yotpo-reviews')];
      yotpoReviewsContainers.forEach((item, index) => {
        item.textContent = bottomline.total_review;
      })

      hideYotpoReviews();

      addAndRemoveClass(".go-ask-question-close", "#write-a-review", "min-h-auto", 'add', false);
      addAndRemoveClass(".infinite-scroll-reviews-close", ".container-infinite", "dn-i", 'add', true);
    } else {
      const empty = [...document.querySelectorAll('.info-product-detail__rating')];
      const hideYotpoReviewsContainer = document.querySelector('.baseline-pdp__yotpo-carousel')
      hideYotpoReviewsContainer.remove();
      empty.forEach(item => item.remove())
    }

    const yotpoScoreContainers = [...document.querySelectorAll('.baselite-pdp-yotpo-score')];
    for (const item of yotpoScoreContainers) {
      if (item.dataset.id) {
        const { bottomline: _bottomline } = await getYotpoReviews(item.dataset.id, 1, 1);
        item.textContent = Math.round(_bottomline.average_score * 100) / 100;
      } else {
        item.textContent = Math.round(bottomline.average_score * 100) / 100;
      }
    }
  }

  const renderedReviewIds = new Set(); // Track rendered review IDs

  async function renderInfinityReviews(page, per_page) {
    const loadMore = document.querySelector('.load_more');
    const allItemsLoaded = document.querySelector('.all-items-loaded');
    const fadeInBottom = document.querySelector('#infinite-scroll-trigger');
    const { reviews, bottomline } = await getYotpoReviews(productPdp.id, page, per_page);
    total_reviews = bottomline.total_review;

    if (reviews.length === 0) {
      clearInterval(intervalId);
      if (fadeInBottom) fadeInBottom.classList.remove('fade-in-bottom')
      if (allItemsLoaded) allItemsLoaded.classList.remove('dn');
      if (loadMore) loadMore.remove();
      return;
    }
    if (reviews.length < 6) {
      document.querySelector('#infinite-scroll-trigger').classList.toggle('fade-in-bottom')
    }


    for (const review of reviews) {
      if (!renderedReviewIds.has(review.id)) {
        const reviewItem = generateReviewHtml(review, false, 'review-infinite');
        reviewItem.classList.add('fade-in');
        document.querySelector('#infinite-scroll-trigger').appendChild(reviewItem);
        renderedReviewIds.add(review.id); // Add rendered review ID to the set
      }
    }

    PAGE++;
  }

  function generateReviewHtml(review, splitText) {
    const reviewItem = document.createElement('div');
    reviewItem.classList.add('review-item', 'box');
    reviewItem.dataset.reviewId = review.id; // Add data attribute for review ID
    reviewItem.innerHTML = `
      <div class="review-content-yotpo">
      <div class="review-rating">${generateRatingStars(review.score)} </div>
      <div class="review-title sans-light-pdp f-bold">${review.title.trim().length > 33 ? review.title.slice(0, 33) + '...' : review.title}</div>
      <div class="review-content sans-light-pdp"> ${splitText ? `<div class="review-content sans-light-pdp">${review.content.trim().length > 110 ? review.content.slice(0, 110) + '...' : review.content}</div>` : `<div class="review-content sans-light-pdp">${review.content}</div>`}</div>
      <div class="review-author sans-light-pdp fc-gray-lt">${review.user.display_name} - ${generateDate(review.created_at)}</div>
      </div> 
    `;
    return reviewItem;
  }

  function generateRatingStars(rating) {
    let ratingStars = '';
    let ratingValue = parseFloat(rating);
    let svgStarIcon = '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.6334 6.17371C15.5157 5.80846 15.176 5.55871 14.789 5.55871H10.3434L8.83828 1.14871C8.71529 0.791706 8.37932 0.548706 7.99835 0.548706C7.61739 0.548706 7.28142 0.790206 7.15843 1.14871L5.65482 5.55721H1.20847C0.823751 5.55721 0.481032 5.80621 0.364042 6.17221C0.245553 6.53971 0.379041 6.93721 0.694013 7.16071L4.24494 9.67846L2.73158 14.1095C2.60859 14.4725 2.73158 14.8745 3.0428 15.1025C3.35402 15.3305 3.77024 15.335 4.08521 15.1145L7.9991 12.3365L11.9138 15.1137C12.0682 15.2232 12.2482 15.2772 12.4282 15.2772C12.6157 15.2772 12.8009 15.2172 12.9569 15.1025C13.2644 14.8737 13.3896 14.4725 13.2644 14.1095L11.7533 9.67996L15.3042 7.16296C15.6147 6.93796 15.7504 6.54046 15.6342 6.17296L15.6334 6.17371Z" fill="#FFD400"/></svg>'
    // Generate full stars
    for (let i = 0; i < Math.floor(ratingValue); i++) {

      ratingStars += `<span class="star-icon">${svgStarIcon}</span>`;
    }

    // Generate half star
    if (ratingValue % 1 >= 0.5) {
      ratingStars += '<span class="star-icon half-star"></span>';
    }

    // Generate empty stars
    for (let i = Math.ceil(ratingValue); i < 5; i++) {
      ratingStars += '<span class="star-icon empty-star"></span>';
    }

    return `<span class="rating-stars rating-stars gap-5px flex">${ratingStars}</span>`;
  }

  function hideYotpoReviews() {
    const product__baseline = document.querySelector('.info-container .info-product-detail__rating');
    const product__baseline_mobile = document.querySelector('.product-baseline-media .info-product-detail_mobile .info-product-detail__rating');
    // const ratingContent = document.querySelector('#baselite-pdp-yotpo-reviews').textContent;
    // if (ratingContent != null & parseInt(ratingContent) < 4) {
    //   if (product__baseline != null) product__baseline.classList.add('dn-i')
    //   if (product__baseline_mobile != null) product__baseline_mobile.classList.add('dn-i')
    // }
  }

  //utility functions
  function waitForElement(selector) {
    return new Promise(resolve => {
      const element = document.querySelector(selector);
      if (element) {
        return resolve(element);
      }

      const observer = new MutationObserver(mutations => {
        const element = document.querySelector(selector);
        if (element) {
          resolve(element);
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  function waitForYotpoAppKey() {
    if (window.yotpo && window.yotpo.appKey) {
      if (carouselContainer) renderYotpoCarousel();
      else setTimeout(renderYotpoCarousel, 100)

      if (bottomLine) hideYotpoReviews();
      else setTimeout(hideYotpoReviews, 100);

    } else {
      setTimeout(waitForYotpoAppKey, 100);
    }
  }
  function generateDate(created_at) {
    const dateString = created_at;
    const date = new Date(dateString);
    const options = { month: 'long', day: 'numeric', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }
  function generateRatingStars(rating) {
    let ratingStars = '';
    let ratingValue = parseFloat(rating);
    let svgStarIcon = '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.6334 6.17371C15.5157 5.80846 15.176 5.55871 14.789 5.55871H10.3434L8.83828 1.14871C8.71529 0.791706 8.37932 0.548706 7.99835 0.548706C7.61739 0.548706 7.28142 0.790206 7.15843 1.14871L5.65482 5.55721H1.20847C0.823751 5.55721 0.481032 5.80621 0.364042 6.17221C0.245553 6.53971 0.379041 6.93721 0.694013 7.16071L4.24494 9.67846L2.73158 14.1095C2.60859 14.4725 2.73158 14.8745 3.0428 15.1025C3.35402 15.3305 3.77024 15.335 4.08521 15.1145L7.9991 12.3365L11.9138 15.1137C12.0682 15.2232 12.2482 15.2772 12.4282 15.2772C12.6157 15.2772 12.8009 15.2172 12.9569 15.1025C13.2644 14.8737 13.3896 14.4725 13.2644 14.1095L11.7533 9.67996L15.3042 7.16296C15.6147 6.93796 15.7504 6.54046 15.6342 6.17296L15.6334 6.17371Z" fill="#FFD400"/></svg>'
    // Generate full stars
    for (let i = 0; i < Math.floor(ratingValue); i++) {

      ratingStars += `<span class="star-icon">${svgStarIcon}</span>`;
    }

    // Generate half star
    if (ratingValue % 1 >= 0.5) {
      ratingStars += '<span class="star-icon half-star"></span>';
    }

    // Generate empty stars
    for (let i = Math.ceil(ratingValue); i < 5; i++) {
      ratingStars += '<span class="star-icon empty-star"></span>';
    }

    return `<span class="rating-stars rating-stars gap-5px flex">${ratingStars}</span>`;
  }

  // Functions of the Intersection Observer
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(async (entry) => {
      if (entry.target.classList.contains('load_more') && entry.isIntersecting) {
        clearInterval(intervalId);
        intervalId = setInterval(async () => {
          const PER_PAGE = parseInt(document.querySelector('#infinite-scroll-trigger').dataset.reviewPerPage);
          await renderInfinityReviews(PAGE, PER_PAGE);
        }, 1000);

      } else if (entry.target.classList.contains('load_more') && !entry.isIntersecting) {
        clearInterval(intervalId);
      }
    });
  }, observerOptions);

  function setupIntersectionObserver() {
    const load_more = document.querySelector('.load_more');
    if (load_more) {
      if (!load_moreVisible) {
        observer.observe(load_more);
        load_moreVisible = true;
      }
    } else {
      if (load_moreVisible) {
        observer.disconnect();
        load_moreVisible = false;
      }
      setTimeout(setupIntersectionObserver, 100); // Retry after a delay
    }
  }

  //Update content
  function refreshYotpo() {
    if (window.yotpo && window.yotpo.appKey) return yotpo.refreshWidgets();
    else setTimeout(refreshYotpo, 100);
  }

  //Call functions
  waitForElement('#nosto-swiper-container-refresh-content').then((elm) => {
    setTimeout(refreshYotpo, 3000);
  });
  waitForElement('.yotpo-carousel').then((elm) => {

    waitForYotpoAppKey();
  });

  // Setup intersection observer
  setupIntersectionObserver();
  addAndRemoveClass(".close-popup", ".popup-container", "active", 'remove');
  addAndRemoveClass(".close-popup", ".popup", "active", 'remove');


  const PostReview = document.getElementById('write__review--form')
  PostReview && PostReview.addEventListener('submit', function (event) {
    event.preventDefault();
    let formData = new FormData(this);
    let data = {
      appkey: '71LvKEaaAS6e2QNsOKyGHjeHCgaTM10NJIWnR4uQ',
      custom_fields: {},
    };

    formData.forEach(function (value, key) {
      let property = null;

      if (key === 'score') {
        property = 'review_score';
      } else if (key === 'title') {
        property = 'review_title';
      } else if (key === 'review') {
        property = 'review_content';
      } else if (key === 'name') {
        property = 'display_name';
      } else if (key === 'email') {
        property = 'email';
      } else if (key === 'size') {
        property = 'size';
      } else if (key === 'sku' || key === 'product_title' || key === 'product_url' || key === 'domain') {
        property = key;
      }

      if (property) {
        if (property === 'size') {
          let value = formData.get('size');

          value = parseInt(value);
          value = isNaN(value) ? 0 : parseInt(value);
        } else {
          data[property] = property === 'review_score'
            ? (isNaN(parseInt(value))
              ? 0
              : parseInt(value)
            ) : value;
        }
      }
    });

    document.getElementById('write__review--form-submit').setAttribute('disabled', true);

    storeReviewData(data, function () {
      document.getElementById('write__review--form').style.display = 'none';
      document.querySelector('.write__review--success').style.display = 'block';
      document.getElementById('write__review--form-submit').removeAttribute('disabled');

      window.scrollTo({
        top: document.getElementById('reviews-form-section').offsetTop - 90,
        behavior: 'smooth'
      });

    }, function (XMLHttpRequest) {
      var response = eval("(" + XMLHttpRequest.responseText + ")");
      response = response.description;
      console.log(`Yotpo error: ${response}`);
      document.getElementById('write__review--form-message').innerHTML = response ? response : "There was an error storing the review. Please try again.";
      document.getElementById('write__review--form-submit').removeAttribute('disabled');
    });
  });
})();

function addAndRemoveClass(selector, selectElement, cLass, event, blcBody) {
  let selectorV = document.querySelector(selector);
  let selectElementV = document.querySelector(selectElement);

  if (selectorV) {
    selectorV.addEventListener('click', () => {
      if (event == 'add') {
        if (blcBody) document.querySelector('body').style.overflow = 'auto';
        selectElementV.classList.add(cLass);
      }
      if (event == 'remove') return selectElementV.classList.remove(cLass);
    })
  }
}

const storeReviewData = (data, callback, error) => {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', 'https://api.yotpo.com/v1/widget/reviews');
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onload = function () {
    if (xhr.status === 200) {
      callback && callback(JSON.parse(xhr.response));
    } else {
      error && error(xhr);
    }
  };
  xhr.onerror = function () {
    error && error(xhr);
  };
  xhr.send(JSON.stringify(data));
};

function openInfiniteWriteRev(action, container) {
  let write__review = document.querySelector('#write-a-review');
  container.classList.remove('dn-i');
  if (!action) write__review.classList.remove('min-h-auto');
}

const linkToSmooth = (link, open) => {

  smoothScrollTo(link);
  if (open) {
    let accordion = document.querySelector('.Shipping--Returns .accordion-pdp');
    if (!accordion.classList.contains('active-pdp')) accordion.click();
  }
}

const linkToSmoothPopup = (link, action, event) => {
  event.preventDefault();
  let containerInf = document.querySelector('.container-infinite');
  const popupModal = containerInf.dataset.popupModalInfinite;
  if (popupModal == 'true') {
    document.querySelector('body').style.overflow = 'hidden'
    containerInf.classList.add('popup-infinite', 'fade-in');
    containerInf.classList.remove('dn-i');

  } else {
    smoothScrollTo(link);
  }
  if (!action) openInfiniteWriteRev(action, containerInf);
  if (action) containerInf.classList.remove('dn-i');
}

const smoothScrollTo = (target) => {
  const targetElement = document.querySelector(target);
  const draggable = document.querySelector('.info-container-draggable')
  if (draggable) draggable.style.top = '5px';

  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: 'smooth'
    });
  }
}

function shareSocialMedia(event) {
  event.preventDefault()
  event.stopPropagation()
  event.target.nextElementSibling && event.target.nextElementSibling.classList.add('flex')
}

function share(socialMedia, event) {
  // Define the URL or content to be shared
  var sharedContent = socialMedia + encodeURIComponent(location.href);
  window.open(sharedContent, '_blank');
  event && event.target.parentElement.classList.remove('flex')
}
const containerShare = document.querySelectorAll('.share-options');
[...containerShare].forEach(element => {
  element.addEventListener('click', () => {
    element.classList.remove('flex');
  })
});





